import LocalizedStrings from 'localized-strings';

/**
 * @todo [multi-receipt] Uncomment plural translations
 */
const locales = new LocalizedStrings({
  en: {
    dropZone: {
      subtitle: 'or drag and drop here',
      // title: 'Add your documents',
      title: 'Add a document',
    },
    error: 'An error occurred',
    uploading: 'Uploading...',
  },
  fr: {
    dropZone: {
      // subtitle: 'ou glissez les ici',
      // title: 'Ajoutez vos justificatifs',
      subtitle: 'ou glissez le ici',
      title: 'Ajoutez votre justificatif',
    },
    error: 'Une erreur est survenue',
    uploading: 'En cours de téléchargement...',
  },
} as const);

export default locales;
